<template>
  <transition name="slide-fade">
    <div class="panel">
      <p>
        Before we begin tracking your symptoms and behaviors, <br />
        let's connect your Fitbit.
      </p>

      <p class="error" v-if="error">
        Something went wrong, please try clicking the connect your fitbit button
        again
      </p>

      <button class="button" @click="generateCodeChallenge()">
        Connect your Fitbit
      </button>
    </div>
  </transition>
</template>

<script>
import firebase from "firebase/app";
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      error: false,
    };
  },

  async mounted() {
    this.changePageTitle("Connect Your Fitbit");
    this.changePageIntroText("");

    // Grab query params.
    const params = new URLSearchParams(window.location.search);

    // Check to see if we have a code.
    if (params.has("code")) {
      const code = params.get("code");

      const url = new URL("https://api.fitbit.com/oauth2/token");

      url.search = new URLSearchParams({
        client_id: "23BH8P",
        code,
        code_verifier: sessionStorage.getItem("codeVerifier"),
        grant_type: "authorization_code",
        redirect_uri: `${window.location.origin}/app/fitbit`,
      });

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };

      const response = await fetch(url.href, options);
      const body = await response.json();

      // Show error if something doesn't work.
      if (!body.success) {
        this.error = true;
      }

      if (response.status === 200) {
        this.error = false;

        // Store tokens in database.
        const realtimeDB = firebase.database();

        // Set db emulator if we're local.
        if (location.hostname === "localhost") {
          realtimeDB.useEmulator("localhost", 9000);
        }

        // Store tokens in DB.
        await realtimeDB.ref(`/fitbit/${body.user_id}`).set({
          accessToken: body.access_token,
          refreshToken: body.refresh_token,
          uid: firebase.auth().currentUser.uid,
        });

        // Send to the steps page.
        this.$router.push("/steps");
      }
    }
  },

  methods: {
    ...mapMutations(["changePageTitle", "changePageIntroText"]),

    generateRandomString() {
      let text = "";
      const possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (let i = 0; i < 128; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      return text;
    },

    async generateCodeChallenge() {
      // Grab or generate code verifier.
      const codeVerifier =
        sessionStorage.getItem("codeVerifier") || this.generateRandomString();

      // Store the verifier for the session.
      sessionStorage.setItem("codeVerifier", codeVerifier);

      // Encrypt the verifier.
      const encoder = new TextEncoder();
      const encoded = encoder.encode(codeVerifier);
      const encrypted = await crypto.subtle.digest("SHA-256", encoded);

      // Base64 the encrypted verifer.
      const challenge = btoa(String.fromCharCode(...new Uint8Array(encrypted)))
        .replace(/=/g, "")
        .replace(/\+/g, "-")
        .replace(/\//g, "_");

      const fitbitURL = `https://www.fitbit.com/oauth2/authorize?client_id=23BH8P&response_type=code&code_challenge=${challenge}&code_challenge_method=S256&scope=activity&redirect_uri=${
        window.location.origin
      }/app/fitbit`;

      window.location = fitbitURL;
    },
  },

  computed: {
    fitbitURL() {
      return `https://www.fitbit.com/oauth2/authorize?response_type=token&client_id=23BH8P&redirect_uri=${
        window.location.origin
      }/app&scope=activity%20profile&expires_in=604800`;
    },
  },
};
</script>

<style scoped>
p {
  font-size: 1.5rem;
  line-height: 1.5;
}

.error {
  color: red;
  font-size: 1rem;
}

.panel {
  padding: 2rem;
}
</style>
